<body>
  <div class="grid-overlay">
    <app-page-header></app-page-header>
    <div class="reports-data">

      <mat-accordion>
        <mat-expansion-panel [expanded]="isOpenSearchPanel" (opened)="openSearchPanel(true)" [hideToggle]="true">
          <mat-expansion-panel-header>

            <button class="btn-icon btn"  title="Buscar" type="button">
              <i class="material-icons">search</i>
            </button>
          </mat-expansion-panel-header>

          <form>
            <fieldset class="fieldset">

              <div fxLayout="row wrap" class="fild_search">
                <div fxFlex="100" fxFlex.gt-xs="50" class="pr-16">
                  <div class="pb-16">

                    <mat-form-field class="full-width">
                      <!--                                            <mat-label>Desde</mat-label>-->
                      <input
                        matInput
                        [matDatepicker]="pickerDesde"
                        [placeholder]="'customerInvoices.search.datePlaceholder' | translate"
                        [(ngModel)]="filter.since"
                        name="since">
                        <mat-datepicker-toggle matSuffix [for]="pickerDesde"></mat-datepicker-toggle>
                        <mat-datepicker #pickerDesde></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <div fxFlex="100" fxFlex.gt-xs="50" class="pr-16">
                    <div class="pb-16">

                      <mat-form-field class="full-width">
                        <!--                                            <mat-label>Hasta</mat-label>-->
                        <input
                          matInput
                          [matDatepicker]="pickerHasta"
                          [placeholder]="'customerInvoices.search.datePlaceholder' | translate"
                          [(ngModel)]="filter.until"
                          name="until">
                          <mat-datepicker-toggle matSuffix [for]="pickerHasta"></mat-datepicker-toggle>
                          <mat-datepicker #pickerHasta></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>

                  </div>

                </fieldset>
                <div class="button_report_align"fxLayout="row" fxLayoutAlign="end center" >

                  <button
                    mat-raised-button
                    type="button"
                    color="warn"
                    class="ml-16 mr-16 button_report light"
                    (click)="reset()"
                    >
                    <mat-icon>refresh</mat-icon>
                  </button>

                  <button
                    mat-raised-button
                    type="button"
                    color="primary"
                    class="ml-16 button_report blue"
                    [disabled]="!canViewInvoicesReport()"
                    (click)="search()">
                    <mat-icon>search</mat-icon>
                  </button>
                </div>
              </form>
            </mat-expansion-panel>
          </mat-accordion>

          <div class="invoices-table-wrapper">
            <mat-table [dataSource]="dataSource" >

              <ng-container matColumnDef="invoice">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoices.table.id' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="invoice"> {{row.id}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="estatus">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoices.table.status' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="estatus">
                  @if (row.statusDescription) {
                    <div style="display: flex; align-items: center; cursor: pointer; text-decoration: underline;">
                      <span>{{row.statusDescription}}</span>
                    </div>
                  }
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="plan">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoices.table.plan' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="plan"> {{row.planName}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="portal">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoices.table.portal' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="portal"> {{row.serviceName}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="totalInvoice">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoices.table.total' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="totalInvoice"> {{row.totalInvoice}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="refundedAmount">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoices.table.refunded' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="refundedAmount">
                  <span class="refund-amount-cell">
                    {{ formatRefundedAmount(row.refundedAmount) }}
                    @if (row.hasPendingRefund === true) {
                      <span class="refund-pending-badge">{{ 'customerInvoices.table.refundPendingShort' | translate }}</span>
                    }
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="createdAt">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoices.table.createdAt' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="createdAt"> {{row.createdAt}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="paymentDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoices.table.paymentDate' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="paymentDate"> {{row.paymentDate || 'N/A'}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'customerInvoices.table.actions' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="actions">
                  @if (row.statusInvoice == 6) {
                    <button
                      (click)="$event.stopPropagation(); openPopUp(row)" mat-button color="primary">
                    {{ 'customerInvoices.table.refund' | translate }}
                  </button>
                }
                @if (isCancellable(row.statusInvoice)) {
                  <button
                    (click)="$event.stopPropagation(); openCancelChargePopUp(row)" mat-button color="warn">
                    {{ 'customerInvoices.table.cancelCharge' | translate }}
                  </button>
                }
              </mat-cell>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="read(row)"  >
            </mat-row>
          </mat-table>
          <mat-paginator showFirstLastButtons
            [length]="tableService.pager.totalEntities"
            [pageIndex]="tableService.pager.pageIndex"
            [pageSize]="tableService.pager.pageSize"
            [pageSizeOptions]="[20, 50, 100]"
            (page)="list($event)">
          </mat-paginator>
        </div>

      </div>

      <div class="options-buttons">
        <button class="back-btn" (click)="goBack()" >{{ 'customerInvoices.back' | translate }}</button>
      </div>

    </div>
  </body>
